<template>
  <div class="buzz-calc">
    <AppMenu />
    <ForbesBanner />
    <!-- need to push down absolute positioned content -->
    <div class="home-main-content">
      <div class="d-flex justify-content-center align-items-start">
        <main class="fixed-width-container">
          <div class="buzz-header">
            <img class="ask-buzz-hero" src="~@/assets/ask-buzz-header.png">
            <router-link to="/reading" class="more-reading-link">
              <img class="more-reading-img" src="~@/assets/bookcircle.png">
            </router-link>
          </div>
          <div>
            <div class="speech-bubble">
              What are you designing?
            </div>
          </div>
          <div class="d-flex">
            <div class="width-30">
              <Buzz :buzzType="currentBuzz" />
            </div>
            <div class="width-70 form-results-container">
              <!--  -->
              <!-- form -->
              <!--  -->
              <div class="main-form">
                <div class="menu-row">
                  <router-link to="/themepark" class="home-nav-circle nav-circle-one">
                    <div class="nav-circle-text">
                      Theme<br>Parks
                    </div>
                  </router-link>
                </div>
                <div class="menu-row">
                  <router-link to="/museum" class="home-nav-circle nav-circle-two">
                    <div class="nav-circle-text">
                      Museums
                    </div>
                  </router-link>
                </div>
                <div class="menu-row">
                  <router-link to="/freeform" class="home-nav-circle nav-circle-three">
                    <div class="nav-circle-text">
                      Free Form
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <BuzzCircle decorative z="-1" top="200px" left="50%" marginLeft="-420px" size="1000px"/>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import BuzzCircle from '@/components/BuzzCircle.vue'
import AppMenu from '@/components/AppMenu.vue'
import AppFooter from '@/components/AppFooter.vue'
import Buzz from '@/components/Buzz.vue'
import ForbesBanner from '@/components/ForbesBanner.vue'

export default {
  name: 'home',
  data () {
    return {
      buzzQuotes: [],
      currentQuote: '',
      currentBuzz: 'wave'
    }
  },
  components: {
    BuzzCircle,
    AppFooter,
    AppMenu,
    Buzz,
    ForbesBanner
  },
  created () {
    this.currentQuote = this.buzzQuotes[0]
  },
  methods: {}
}
</script>

<style scoped lang="scss">
// home-nav-circle nav-circle-three
  .menu-row{
    width: 100%;
    // all this to push the middle circle to the right...
    display: flex;
    flex-direction: column;
  }
  a.home-nav-circle, .home-nav-circle{
    display: flex;
    background: #51779B;
    text-decoration: none;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    align-items: center;
    .nav-circle-text{
      width: 100%;
      font-size: 18px;
      text-align: center;
      color: #fff;
    }
    .coming-soon-title{
      font-size: 14px;
      text-transform: uppercase;
    }
    &.nav-circle-one{
      background: #5A7798;
    }
    &.nav-circle-two{
      background: #7490AF;
      // all this to push the middle circle to the right...
      align-self: flex-end;
    }
    &.nav-circle-three{
      background: #8AA6C5;
    }
  }
  // media queries
  // Small devices (landscape phones, 576px and up)
  @media (min-width: 576px) {
    a.home-nav-circle, .home-nav-circle{
      width: 200px;
      height: 200px;
      .nav-circle-text{
        font-size: 28px;
      }
      .coming-soon-title{
        font-size: 16px;
      }
      &.nav-circle-two{
        background: #7490AF;
        left: 140px;
      }
    }
  }

  // Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {}

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {}

  // Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {}

  // media queries -at and down-
  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575.98px) {}

  // Small devices (landscape phones, less than 768px)
  @media (max-width: 767.98px) {}

  // Medium devices (tablets, less than 992px)
  @media (max-width: 991.98px) {}

  // Large devices (desktops, less than 1200px)
  @media (max-width: 1199.98px) {}
</style>
